import { Component, OnInit } from "@angular/core";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { RouterLink } from "@angular/router";
@Component({
    selector: "app-page-not-found-page",
    templateUrl: "./page-not-found-page.component.html",
    styleUrls: ["./page-not-found-page.component.scss"],
    standalone: true,
    imports: [
        IonicModule,
        RouterLink,
        TranslatePipe,
    ],
})
export class PageNotFoundPageComponent implements OnInit {
  constructor(private authService: AuthService, public translate: TranslateService) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}
}
